import { SelectItem } from 'primeng/api';

/**
 * Opções de ano para os seletores de referência (mensalidade, ano de cobrança, etc.).
 *
 * EBUG-338: as listas eram escritas à mão em cada tela e paravam no ano em que alguém
 * as atualizou pela última vez — em 2026 não havia como gerar mensalidade para 2027.
 * Gerando a partir do ano corrente, a janela anda sozinha e o defeito não volta.
 */
export const YEARS_BACK = 8;
export const YEARS_AHEAD = 5;

/** Primeiro ano oferecido nas telas de mensalidade/cobrança — o piso que elas já tinham. */
export const PRIMEIRO_ANO_MENSALIDADE = 2018;

/**
 * Janela deslizante em torno do ano corrente. Para telas de lançamento/operação, em que
 * o passado distante não interessa.
 */
export function buildYearOptions(yearsBack: number = YEARS_BACK, yearsAhead: number = YEARS_AHEAD): SelectItem[] {
  const currentYear = new Date().getFullYear();
  return buildYearRange(currentYear - yearsBack, currentYear + yearsAhead);
}

/**
 * Piso fixo e teto deslizante. Para telas que consultam lançamentos antigos: o ano inicial
 * não pode andar com o relógio, senão o histórico some do filtro com o passar dos anos.
 */
export function buildYearOptionsFrom(startYear: number, yearsAhead: number = YEARS_AHEAD): SelectItem[] {
  return buildYearRange(startYear, new Date().getFullYear() + yearsAhead);
}

function buildYearRange(startYear: number, endYear: number): SelectItem[] {
  const options: SelectItem[] = [];

  for (let year = startYear; year <= endYear; year++) {
    options.push({ label: String(year), value: year });
  }

  return options;
}
